import { FormattedMessage } from 'react-intl'
import Button from '../../components/button/Button'
import React from 'react'
import { useMediaQuery } from 'react-responsive'
import { ClassValue } from 'classnames/types'
import classNames from 'classnames'
import { makeStyles } from '@material-ui/core/styles'
import styles from '../../styles'
import { displayModal } from '../reducers/modal/actions'
import { connect } from 'react-redux'
import { modalTypes } from '../../enums/modalTypeEnum'
import { saveInteractions } from '../gtm/utils/gtmCallback'
import { Grid } from '@material-ui/core'

const useStyle = makeStyles(
    (theme) => (
        {
            ...styles(theme),
            makeRequestStyle: {
                background: theme.palette.accessibility.main,
                marginTop: 70
            },
            makeRequestLargeScreenStyle: {
                padding: '55px 70px 60px 50px'
            },
            makeRequestSmallScreenStyle: {
                padding: 20,

                '& div:first-child': {
                    marginBottom: 30
                }
            }
        }
    )
)

interface Store {
    detailView?: boolean,
    displayModal: (modalType: string, content: any) => void,
    fetchRequestsList?: () => void
}

type NewDemandeProps = Store

const FooterNewDemande: React.FC<NewDemandeProps> = (
    {
        detailView = false,
        displayModal,
        fetchRequestsList
    }
) => {
    const classes = useStyle()

    const isLargeScreen = useMediaQuery(
        {
            query: '(min-width: 1025px)'
        }
    )

    const makeRequestClass: ClassValue = classNames(
        classes.makeRequestStyle,
        classes.flexBetween,
        {
            [classes.makeRequestLargeScreenStyle]: isLargeScreen,
            [classes.makeRequestSmallScreenStyle]: !isLargeScreen
        }
    )

    const titleMakeRequestClass: ClassValue = classNames(
        'col-xs-12 col-md-7',
        classes.colorWhite,
        {
            [classes.text0]: isLargeScreen,
            [classes.text7]: !isLargeScreen
        }
    )

    return <Grid container item xs={12} alignItems="center" className={makeRequestClass}>
        {detailView ?
            <div className={titleMakeRequestClass}>
                <FormattedMessage
                    id="requests.anotherRequest"
                    defaultMessage="Vous souhaitez déposer une nouvelle demande ?"
                    description="Another request"
                />
            </div>
            :
            <div className={titleMakeRequestClass}>
                <FormattedMessage
                    id="requests.responseNotFound"
                    defaultMessage="Vous n’avez pas trouvé de réponse dans nos questions fréquentes ?"
                    description="Request no response"
                />
            </div>
        }


        <div className="col-xs-12 col-md-3">
            <Button
                background="backgroundWhite"
                color="colorAccessibility"
                textStyle="text8"
                onClick={() => {
                    saveInteractions(
                        {
                            category: 'Vos Demandes',
                            action: 'Déposer une demande',
                            label: 'Etape 0::Call to action'
                        }
                    )

                    displayModal(modalTypes.demandes, { callback: fetchRequestsList })
                }}
            >
                <FormattedMessage
                    id="requests.makeRequest.title"
                    defaultMessage="Déposer une demande"
                    description="Request make request"
                />
            </Button>
        </div>
    </Grid>
}

const mapDispatchToProps = {
    displayModal
}

export default connect(undefined, mapDispatchToProps)(FooterNewDemande)
